import { createFileRoute } from '@tanstack/react-router';
import { SignaturesPage } from '@/features/signatures';

/** Signatures: the requests to sign and the ones the member sent. */
export const Route = createFileRoute('/_auth/o/$orgId/signatures/')({
  component: SignaturesRoute,
});

function SignaturesRoute() {
  const { orgId } = Route.useParams();
  return <SignaturesPage orgId={orgId} />;
}
